import { Typography, Box } from '@mui/material';
import Button from '@mui/material/Button';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import CDNRoot from './CDN/index';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const Home = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [value, setValue] = useState(0);
    const [user] = useState(JSON.parse(localStorage.getItem("user") || "false") || false);
    const hasSharedFolder = !!new URLSearchParams(location.search).get("folder");

    useEffect(() => {
        // Shared-folder links are read-only for visitors without an account; do not bounce
        // them to /login when the address bar changes as they browse subfolders.
        if (!user && !hasSharedFolder) navigate("/login");
    }, [user, hasSharedFolder, navigate]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box style={{ marginTop: 20, margin: 0,  }}>
            <CDNRoot />
        </Box>
    );
};

export default Home;